export default {
  acetate: { field: 'acetate' },
  acetateDisplay: { field: 'acetateDisplay' },
  acetateSeverityId: { field: 'acetateSeverityID' },
  aluminum: { field: 'aluminum', title: 'Al' },
  aluminumDisplay: { field: 'aluminumDisplay' },
  aluminumSeverityId: { field: 'aluminumSeverityID', fieldType: 'numeric' },
  antifreezePercent: { field: 'antifreezePercent', fieldType: 'numeric', title: 'Glycol %' },
  antifreezePercentSign: { field: 'antifreezePercentSign' },
  antifreezePercentSeverityId: { field: 'antifreezePercentSeverityID' },
  billingDescription: { field: 'billingDescription' },
  billingThirdParty: { field: 'billingThirdParty' },
  boilPoint: { field: 'boilPoint' },
  boilPointDisplay: { field: 'boilPointDisplay' },
  boilPointSeverityId: { field: 'boilPointSeverityID' },
  boron: { field: 'boron', title: 'B' },
  boronDisplay: { field: 'boronDisplay' },
  boronSeverityId: { field: 'boronSeverityID', fieldType: 'numeric' },
  calcium: { field: 'calcium', title: 'Ca' },
  calciumDisplay: { field: 'calciumDisplay' },
  calciumSeverityId: { field: 'calciumSeverityID', fieldType: 'numeric' },
  chloride: { field: 'chloride' },
  chlorideDisplay: { field: 'chlorideDisplay' },
  chlorideSeverityId: { field: 'chlorideSeverityID', fieldType: 'numeric' },
  clarityResultId: { field: 'clarityResultID', fieldType: 'numeric' },
  claritySeverityId: { field: 'claritySeverityID', fieldType: 'numeric' },
  color: { field: 'color' },
  colorSeverityId: { field: 'colorSeverityID', fieldType: 'numeric' },
  commentId: { field: 'commentID' },
  comments: { field: 'comments' },
  coolantSampleId: { field: 'coolantSampleID', title: 'ID', fieldType: 'numeric' },
  copper: { field: 'copper', title: 'Cu', fieldType: 'numeric' },
  copperDisplay: { field: 'copperDisplay' },
  copperSeverityId: { field: 'copperSeverityID', fieldType: 'numeric' },
  createdOn: { field: 'createdOn' },
  customerCode: { field: 'customerCode' },
  customerComments: { field: 'customerComments' },
  customerId: { field: 'customerID', fieldType: 'numeric' },
  customerName: { field: 'customerName' },
  customerThirdParty: { field: 'customerThirdParty' },
  dateReceived: { field: 'dateReceived', fieldType: 'datetime' },
  dateSampled: { field: 'dateSampled' },
  elcPassFail: { field: 'elcPassFail', title: 'ELC Pass Fail' },
  elcPassFailSeverityId: { field: 'elcPassFailSeverityID' },
  fluoride: { field: 'fluoride' },
  fluorideDisplay: { field: 'fluorideDisplay' },
  fluorideSeverityId: { field: 'fluorideSeverityID', fieldType: 'numeric' },
  fluidActionCode: { field: 'fluidActionCode' },
  fluidActionId: { field: 'fluidActionID', fieldType: 'numeric' },
  fluidActionName: { field: 'fluidActionName' },
  fluidCode: { field: 'fluidCode' },
  fluidId: { field: 'fluidID', fieldType: 'numeric' },
  fluidName: { field: 'fluidName' },
  foam: { field: 'foam' },
  foamSeverityId: { field: 'foamSeverityID', fieldType: 'numeric' },
  formate: { field: 'formate' },
  formateDisplay: { field: 'formateDisplay' },
  formateSeverityId: { field: 'formateSeverityID', fieldType: 'numeric' },
  freezePoint: { field: 'freezePoint' },
  freezePointDisplay: { field: 'freezePointDisplay' },
  freezePointSeverityId: { field: 'freezePointSeverityID', fieldType: 'numeric' },
  fuel: { field: 'fuel', fieldType: 'numeric' },
  fuelSeverityId: { field: 'fuelSeverityID', fieldType: 'numeric' },
  glycolate: { field: 'glycolate' },
  glycolateDisplay: { field: 'glycolateDisplay' },
  glycolateSeverityId: { field: 'glycolateSeverityID', fieldType: 'numeric' },
  hardness: { field: 'hardness' },
  hardnessDisplay: { field: 'hardnessDisplay' },
  hardnessSeverityId: { field: 'hardnessSeverityID', fieldType: 'numeric' },
  iron: { field: 'iron', title: 'Fe' },
  ironDisplay: { field: 'ironDisplay' },
  ironSeverityId: { field: 'ironSeverityID', fieldType: 'numeric' },
  isBillable: { field: 'isBillable' },
  isBillingBasicSample: { field: 'isBillingBasicSample' },
  isBillingNC: { field: 'isBillingNC' },
  isBillingNOB: { field: 'isBillingNOB' },
  isBillingPT: { field: 'isBillingPT' },
  isBillingRUSH: { field: 'isBillingRUSH' },
  isBillingST: { field: 'isBillingST' },
  lead: { field: 'lead', title: 'Pb' },
  leadDisplay: { field: 'leadDisplay' },
  leadSeverityId: { field: 'leadSeverityID', fieldType: 'numeric' },
  magnesium: { field: 'magnesium', title: 'Mg' },
  magnesiumDisplay: { field: 'magnesiumDisplay' },
  magnesiumSeverityId: { field: 'magnesiumSeverityID', fieldType: 'numeric' },
  magneticPrecipitateResultId: { field: 'magneticPrecipitateResultID', fieldType: 'numeric' },
  magneticPrecipitateSeverityId: { field: 'magneticPrecipitateSeverityID', fieldType: 'numeric' },
  manufacturerModelName: { field: 'manufacturerModelName', title: 'Manufacturer Model' },
  meterReading: { field: 'meterReading' },
  meterReadingSampleUnitOfMeasureId: {
    field: 'meterReadingSampleUnitOfMeasureID',
    fieldType: 'numeric'
  },
  meterReadingUnitOfMeasureName: { field: 'meterReadingUnitOfMeasureName' },
  milesOrHoursOnSample: { field: 'milesOrHoursOnSample' },
  milesOrHoursOnSampleUnitOfMeasureId: {
    field: 'milesOrHoursOnSampleUnitOfMeasureID',
    fieldType: 'numeric'
  },
  milesOrHoursOnSampleUnitOfMeasureName: { field: 'milesOrHoursOnSampleUnitOfMeasureName' },
  modifiedOn: { field: 'modifiedOn' },
  molybdenum: { field: 'molybdenum', title: 'Mo' },
  molybdenumDisplay: { field: 'molybdenumDisplay' },
  molybdenumSeverityId: { field: 'molybdenumSeverityID', fieldType: 'numeric' },
  nitrate: { field: 'nitrate' },
  nitrateDisplay: { field: 'nitrateDisplay' },
  nitrateSeverityId: { field: 'nitrateSeverityID', fieldType: 'numeric' },
  nitrite: { field: 'nitrite' },
  nitriteDisplay: { field: 'nitriteDisplay' },
  nitriteSeverityId: { field: 'nitriteSeverityID', fieldType: 'numeric' },
  nonMagneticPrecipitateResultId: { field: 'nonMagneticPrecipitateResultID', fieldType: 'numeric' },
  nonMagneticPrecipitateSeverityId: {
    field: 'nonMagneticPrecipitateSeverityID',
    fieldType: 'numeric'
  },
  odor: { field: 'odor' },
  odorSeverityId: { field: 'odorSeverityID' },
  oilResultId: { field: 'oilResultID' },
  oilSampleId: { field: 'oilSampleID', fieldType: 'numeric' },
  oilSeverityId: { field: 'oilSeverityID' },
  oxalate: { field: 'oxalate', fieldType: 'numeric' },
  oxalateDisplay: { field: 'oxalateDisplay' },
  oxalateSeverityId: { field: 'oxalateSeverityID' },
  ph: { field: 'ph' },
  phDisplay: { field: 'phDisplay' },
  pHSeverityId: { field: 'pHSeverityID' },
  phosphate: { field: 'phosphate', fieldType: 'numeric' },
  phosphateDisplay: { field: 'phosphateDisplay' },
  phosphateSeverityId: { field: 'phosphateSeverityID' },
  phosphorous: { field: 'phosphorus', title: 'P' },
  phosphorusDisplay: { field: 'phosphorusDisplay' },
  phosphorusSeverityId: { field: 'phosphorusSeverityID' },
  potassium: { field: 'potassium', title: 'K' },
  potassiumDisplay: { field: 'potassiumDisplay' },
  potassiumSeverityId: { field: 'potassiumSeverityID' },
  sampleNumber: { field: 'sampleNumber', required: true, fieldType: 'numeric' },
  sampleSeverityName: { field: 'sampleSeverityName' },
  severityId: { field: 'severityID', fieldType: 'numeric' },
  silicon: { field: 'silicon', title: 'Si' },
  siliconDisplay: { field: 'siliconDisplay' },
  siliconSeverityId: { field: 'siliconSeverityID', fieldType: 'numeric' },
  sodium: { field: 'sodium', title: 'Na' },
  sodiumDisplay: { field: 'sodiumDisplay' },
  sodiumSeverityId: { field: 'sodiumSeverityID', fieldType: 'numeric' },
  specificConductance: { field: 'specificConductance' },
  specificConductanceDisplay: { field: 'specificConductanceDisplay' },
  specificConductanceSeverityId: { field: 'specificConductanceSeverityID', fieldType: 'numeric' },
  sulfate: { field: 'sulfate' },
  sulfateDisplay: { field: 'sulfateDisplay' },
  sulfateSeverityId: { field: 'sulfateSeverityID', fieldType: 'numeric' },
  tds: { field: 'tds', title: 'TDS' },
  tdsDisplay: { field: 'tdsDisplay', title: 'TDS' },
  tdsSeverityId: { field: 'tdsSeverityID' },
  tin: { field: 'tin', title: 'Sn', fieldType: 'numeric' },
  tinDisplay: { field: 'tinDisplay' },
  tinSeverityId: { field: 'tinSeverityID', fieldType: 'numeric' },
  unitId: { field: 'unitID', fieldType: 'numeric' },
  unitName: { field: 'unitName' },
  unitTypeName: { field: 'unitTypeName', title: 'Unit Type' },
  zinc: { field: 'zinc', title: 'Zn' },
  zincDisplay: { field: 'zincDisplay' },
  zincSeverityId: { field: 'zincSeverityID', fieldType: 'numeric' }
};
